module.exports = __webpack_public_path__ + "img/share-hasprize.e5e87794.png";